import { render, staticRenderFns } from "./modal-note.vue?vue&type=template&id=526140bb&scoped=true&"
import script from "./modal-note.vue?vue&type=script&lang=ts&"
export * from "./modal-note.vue?vue&type=script&lang=ts&"
import style0 from "./modal-note.vue?vue&type=style&index=0&id=526140bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526140bb",
  null
  
)

export default component.exports